// src/components/chat/LinkPreview.jsx

import './LinkPreview.css';

const LinkPreview = ({ preview }) => {
    if (!preview) return null;

    const getHostname = (url) => {
        try { 
            return new URL(url).hostname; 
        } catch { 
            return ''; 
        }
    };

    return (
        <a 
            href={preview.url} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="link-preview"
        >
            {preview.image && (
                <div className="link-preview-image"><img src={preview.image} alt={preview.title || ''} /></div>
            )}
            <div className="link-preview-content">
                <div className="link-preview-site">{preview.site_name || getHostname(preview.url)}</div>
                <div className="link-preview-title">  {preview.title || preview.url}  </div>
                {preview.description && (<div className="link-preview-description">{preview.description.substring(0, 150)} </div>  )}
            </div>
        </a>
    );
};

export default LinkPreview;